export const BUILD_ID = process.env.REACT_APP_BUILD_ID || 'dev';
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || '';
export const BUILD_GIT_SHA = process.env.REACT_APP_GIT_SHA || '';
export const IS_PRODUCTION_BUILD = process.env.NODE_ENV === 'production';
